/*
 * Thanks: Amir Wald (http://colnect.com)
 */
t_jp.l = {
    'Close without saving?': 'לסגור בלי לשמור?',
    'You have made a change to the translation. Are you sure you want to discard it?': 'ביצעת שינוי בתרגום, האם אתה בטוח שאתה רוצה לוותר עליו?',
    'History': 'היסטוריה',
    'Loading...': 'טוען...',
    'Translated': 'תורגם',
    'By': 'על ידי',
    'At': 'ב',
    'google': 'גוגל',
    'bing': 'בינג',
    'apertium': 'אפרטיום',
    'manual translation': 'תרגום ידני',
    'bing suggest': 'הצעות בינג',
    'google suggest': 'הצעות גוגל',
    'apertium suggest': 'הצעות אפרטיום',
    'Edit Translation': 'עריכת תרגום',
    'Original text': 'טקסט מקורי',
    'read alternate translations': 'קרא תרגומים אלטרנטיביים',
    'previous translation': 'תרגום קודם',
    'find on page': 'מצא בדף',
    'next translation': 'תרגום הבא',
    'Translate to': 'תרגם ל',
    'view translation log': 'הצג לוג תרגום',
    'virtual keyboard': 'מקלדת וירטואלית',
    'approve translation': 'אשר תרגום',
    'delete': 'מחק',
    'Discard': 'וותר',
    'Cancel': 'בטל'
};